import { NgRedux } from '@ptl/angular-redux-store';
import { Injectable } from '@angular/core';
import { Brand, BrandingConfigurationService } from '@ptl/brand';
import { StateStructure } from '@ptl/state';
import { Moment } from 'moment';
import { DateService } from 'src/app/shared/services/date.service';
import { ReducerUtilityService } from 'src/app/shared/utility-services/reducer-utility.service';
import { ONXEligibilityResponseApplicant, CustomerData } from '../interfaces/eligibility.interface';
import {
  Family,
  OnExchangeEnrollPerson,
  OnExchangeEnrollPersonI
} from '../interfaces/on-exchange-enroll.person.interface';
import {
  addOnExchangeApplicationPerson,
  OnExchangePersonStateStructure,
  ON_EXCHANGE_PERSON_REDUCER_NAME,
  resetOnExchangeApplicationPersons
} from '../reducers/on-exchange.person.reducer';
//import * as moment from 'moment';
import moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class PersonManagerService {
  constructor(
    private ngRedux: NgRedux<StateStructure>,
    private reducerUtilityService: ReducerUtilityService,
    private dateService: DateService,
    private brandService: BrandingConfigurationService
  ) {}

  query(
    predicate: (person: OnExchangeEnrollPersonI) => boolean
  ): OnExchangeEnrollPersonI[] {
    const onExchangePersonState: OnExchangePersonStateStructure
      = this.reducerUtilityService.getComponentStates()[ON_EXCHANGE_PERSON_REDUCER_NAME];
    return onExchangePersonState.persons.filter(predicate);
  }
  put(person: OnExchangeEnrollPersonI): void {
    this.ngRedux.dispatch(addOnExchangeApplicationPerson(person));
  }
  add(person: OnExchangeEnrollPersonI): boolean {
    const onExchangePersonState: OnExchangePersonStateStructure
      = this.reducerUtilityService.getComponentStates()[ON_EXCHANGE_PERSON_REDUCER_NAME];

    /**
     * I'm just trying to handle this functionality as DOJO.Memory does, where it checks for an existing value;
     * However, they provide a pseudo ID when added and then check against it, so, I have no idea if it ever matterd
     * for how it used to be used...
     */
    if (
      !onExchangePersonState.persons.some(p => {
        return (p as unknown as ONXEligibilityResponseApplicant).personID === (person as unknown as ONXEligibilityResponseApplicant).personID;
      })
    ){
      this.put(person);
      return true;
    }
    return false;
  }
  createPersonOnX(
    person: ONXEligibilityResponseApplicant | OnExchangeEnrollPersonI | CustomerData,
    region?: { county: string; state: string; zipcode: string }
  ) {

    const personObject: OnExchangeEnrollPersonI
      = Object.assign(
        {},
        new OnExchangeEnrollPerson(),
        person as ONXEligibilityResponseApplicant
      );
    /**
     * I hope the above line, when using CustomerData or OnExchangeEnrollPersonI, isn't crap..
     * I never managed to fully validate the interfaces 100%, but, got the errors down
     */

    this.add(personObject);
  }
  prune() {
    this.ngRedux.dispatch(resetOnExchangeApplicationPersons());
  }
  get(id: number): OnExchangeEnrollPersonI {
    return this.getAll().filter(r => r.id === id)[0];
  }
  getAll(): OnExchangeEnrollPersonI[] {
    const onExchangePersonState: OnExchangePersonStateStructure
      = this.reducerUtilityService.getComponentStates()[ON_EXCHANGE_PERSON_REDUCER_NAME];
    return JSON.parse(JSON.stringify(onExchangePersonState.persons));
  }

  isLegalSmokingAge(id: number) {
    const currentBrand: Brand = this.brandService.getCurrentBrand();
    const person = this.get(id);

    /** @TODO update with dateOffset from dateService */
    // Can we do a moment( of a momoment which is a string from localstorage ) ) ?
    if (
      currentBrand.individualMarketConstants.ageOfAdulthood < moment(this.dateService.getNow()).diff(moment(person.dateOfBirth), 'year')
    ) {
      return true;
    }
    return false;
  }

  /** Unnecessary, as we'll be storing without the DOJO.Memory.id field */
  // retrievePersonsWithoutId(): OnExchangeEnrollPersonI[] {
  //   throw new Error('Method not implemented.');
  // }
}
